export const fmtCOP = (n) => {
  if (n === null || n === undefined || n === "") return "";
  const num = Number(n);
  if (Number.isNaN(num)) return "";
  return "$" + num.toLocaleString("es-CO");
};

export const serviceLabel = (t) => ({
  aeropuerto: "Traslado Aeropuerto",
  ciudad: "Dentro de la ciudad",
  fuera_ciudad: "Fuera de la ciudad",
  por_horas: "Disponibilidad por horas",
}[t] || t);

export const statusLabel = (s) => ({
  nueva: "Nueva",
  contactada: "Contactada",
  confirmada: "Confirmada",
  cancelada: "Cancelada",
}[s] || s);

export const statusStyle = (s) => ({
  nueva: "bg-amber-500/15 text-amber-300 border-amber-500/40",
  contactada: "bg-blue-500/15 text-blue-300 border-blue-500/40",
  confirmada: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40",
  cancelada: "bg-rose-500/15 text-rose-300 border-rose-500/40",
}[s] || "bg-white/10 text-white/70 border-white/20");

export const whatsappHref = (num, msg = "") => {
  const clean = String(num || "").replace(/[^0-9]/g, "");
  const q = msg ? `?text=${encodeURIComponent(msg)}` : "";
  return `https://wa.me/${clean}${q}`;
};
